/* eb-ereignis.js — Mikrointeraktionen für Ereignis-Ratgeber.
   Progressive Enhancement: ohne dieses Skript bleiben Timeline, Ausfall-Kette
   und Selbst-Check als statischer Inhalt lesbar. */
(function () {
  'use strict';

  var root = document.documentElement;
  if (root.dataset.ebEvInit === '1') return; /* Doppel-Init vermeiden (Asset + Inline-Übergang) */
  root.dataset.ebEvInit = '1';
  root.classList.add('eb-ev-js');

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveal ---------- */
  var revealNodes = Array.prototype.slice.call(document.querySelectorAll('[data-eb-reveal]'));
  if (revealNodes.length) {
    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealNodes.forEach(function (node) { node.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.15 });
      revealNodes.forEach(function (node) { io.observe(node); });
    }
  }

  /* ---------- Ausfall-Kette (Tabs) ---------- */
  Array.prototype.slice.call(document.querySelectorAll('[data-eb-chain]')).forEach(function (chain) {
    var tablist = chain.querySelector('[role="tablist"]');
    var tabs = Array.prototype.slice.call(chain.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(chain.querySelectorAll('[role="tabpanel"]'));
    if (!tablist || tabs.length < 2 || tabs.length !== panels.length) return;

    tablist.hidden = false;

    var select = function (index, focus) {
      tabs.forEach(function (tab, i) {
        var active = i === index;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
        panels[i].hidden = !active;
        if (active && focus) tab.focus();
      });
    };

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(i, false); });
      tab.addEventListener('keydown', function (event) {
        var next = null;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (i + 1) % tabs.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (i - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === null) return;
        event.preventDefault();
        select(next, true);
      });
    });

    select(0, false);
  });

  /* ---------- Selbst-Check ---------- */
  Array.prototype.slice.call(document.querySelectorAll('[data-eb-check]')).forEach(function (box) {
    var inputs = Array.prototype.slice.call(box.querySelectorAll('input[type="checkbox"]'));
    var fill = box.querySelector('[data-eb-check-fill]');
    var result = box.querySelector('[data-eb-check-result]');
    if (!inputs.length || !result) return;

    var total = inputs.length;
    var messages = {
      none: 'Haken Sie an, was bei Ihnen schon vorhanden ist.',
      low: 'Ein Anfang ist gemacht. Die Lücken lassen sich mit Supermarkt und Baumarkt schließen.',
      mid: 'Damit überbrücken Sie die ersten Stunden schon deutlich entspannter.',
      full: 'Ihr Haushalt ist für die ersten Stunden ohne Strom gut aufgestellt.'
    };

    var update = function () {
      var done = inputs.filter(function (input) { return input.checked; }).length;
      if (fill) fill.style.width = Math.round((done / total) * 100) + '%';
      var text;
      if (done === 0) text = messages.none;
      else if (done <= 2) text = '<strong>' + done + ' von ' + total + ' vorhanden.</strong> ' + messages.low;
      else if (done < total) text = '<strong>' + done + ' von ' + total + ' vorhanden.</strong> ' + messages.mid;
      else text = '<strong>' + total + ' von ' + total + ' vorhanden.</strong> ' + messages.full;
      result.innerHTML = text;
    };

    inputs.forEach(function (input) { input.addEventListener('change', update); });
    update();
  });
})();
